import { AxiosError } from 'axios';
import { GET_ADMISSION_EXAM_YEARS_QUERY_KEY } from '../../constants/queryKeys';
import axiosClient from '../axiosClient';
import { GET_ADMISSION_YEARS_URL } from '../../constants/apiUrls';
import { useCustomQuery } from '../utils/useCustomQuery';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Query
// =============================================================================
interface Input {
  onSuccess?: (data: number[]) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const useGetAdmissionYears = ({ onSuccess, onError }: Input = {}) => {
  const getAdmissionYears = async () => {
    const res = await axiosClient.get<number[]>(GET_ADMISSION_YEARS_URL);
    return res.data;
  };

  return useCustomQuery(
    GET_ADMISSION_EXAM_YEARS_QUERY_KEY,
    getAdmissionYears,
    {
      onSuccess,
      onError,
    },
    true,
    false
  );
};
